import React from 'react'
import TopMenu from './TopMenu'
import DBoyList from '../DeliveryBoylist/DBoyList'


const DeliveryBoyData = ({ setActiveTab, activeTab, deliverytData, totalDeliveryData, deleteOrder, searchOrderNo, setSearchOrderNo }) => {
	return (
		<div className='mx-4 min-h-[105vh] pb-6 md:mx-6'>
			<div className='mt-3 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between'>
				<label className='block max-w-[420px] flex-1'>
					<span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Search by order number</span>
					<input
						value={searchOrderNo}
						onChange={(e) => setSearchOrderNo(e.target.value)}
						placeholder='Enter order number'
						className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
					/>
				</label>
				<div className='grid gap-3 sm:grid-cols-2'>
					<div className='rounded-[20px] border border-slate-200 bg-white px-4 py-3 shadow-[0_10px_26px_rgba(15,23,42,0.05)]'>
						<p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Visible runs</p>
						<p className='mt-1 text-sm font-[GilroyBold] text-slate-900'>{deliverytData?.length || 0}</p>
					</div>
					<div className='rounded-[20px] border border-slate-200 bg-white px-4 py-3 shadow-[0_10px_26px_rgba(15,23,42,0.05)]'>
						<p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Total runs</p>
						<p className='mt-1 text-sm font-[GilroyBold] text-slate-900'>{totalDeliveryData?.length || 0}</p>
					</div>
				</div>
			</div>
			<TopMenu activeTab={activeTab} setActiveTab={setActiveTab} />
			<DBoyList deleteOrder={deleteOrder} deliverytData={deliverytData} />
		</div>
	)
}

export default DeliveryBoyData
